<template>
  <vueVimeoPlayer
    v-if="this.sourceVideo == 'Vimeo'"
    class="ratio ratio-16x9"
    :video-id="videoIdVimeo"
  />
  <div v-else class="ratio ratio-16x9">
    <iframe :src="link" frameborder="0" allowfullscreen />
  </div>
</template>

<script>
import { vueVimeoPlayer } from 'vue-vimeo-player'
import { identifySourceVideo, getVideoIdVimeo } from '@/utils/video'

export default {
  name: 'VideoLesson',

  components: {
    vueVimeoPlayer,
  },

  props: {
    link: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      sourceVideo: '',
      videoIdVimeo: '',
    }
  },

  watch: {
    link: {
      handler() {
        this.identifyVideo()
      },
    },
  },

  methods: {
    identifyVideo() {
      this.sourceVideo = identifySourceVideo(this.link)
      if (this.sourceVideo === 'Vimeo') {
        this.videoIdVimeo = getVideoIdVimeo(this.link)
      }
    },
  },

  mounted() {
    this.identifyVideo()
  },
}
</script>

<style scoped>
.ratio {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

@media (min-width: 768px) {
  .ratio {
    width: 50%;
  }
}
</style>
